"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeFeatureFlags = void 0;
Object.defineProperty(exports, "isFeatureFlagEnabled", {
  enumerable: true,
  get: function get() {
    return _selectors.isFeatureFlagEnabled;
  }
});
Object.defineProperty(exports, "reducer", {
  enumerable: true,
  get: function get() {
    return _reducer.default;
  }
});

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _actions = require("./state/actions");

var _reducer = _interopRequireDefault(require("./state/reducer"));

var _selectors = require("./state/selectors");

var initializeFeatureFlags = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(store, consumer, frontApiClient) {
    var dispatch, result;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dispatch = store.dispatch;
            _context.next = 3;
            return frontApiClient.get("feature-flags/".concat(consumer));

          case 3:
            result = _context.sent;
            _context.next = 6;
            return dispatch((0, _actions.saveFeatureFlags)({
              consumer: consumer,
              flags: result.data
            }));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function initializeFeatureFlags(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

exports.initializeFeatureFlags = initializeFeatureFlags;